import React, { FC, useRef } from 'react';

import { Box, HStack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { StackedHeader } from 'components/DataDisplay';
import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';
import { LearnMoreButton } from 'components/DataEntry/Button/LearnMoreButton';
import { Drawer } from 'components/Overlay';
import { UpdateConfig } from 'containers/PolicyHub/Blueprints/Components/Utils/Configure/UpdateConfig';
import { selectBlueprints } from 'containers/PolicyHub/Blueprints/selectors';
import { getBlueprintIcon } from 'containers/PolicyHub/utils';

interface Props {
  isOpen: boolean;
  onClose();
  onSuccess();
}

export const Configure: FC<Props> = props => {
  const { isOpen, onClose, onSuccess } = props;
  const { blueprint } = useSelector(selectBlueprints);
  const ref = useRef(document.querySelector('.portal-container'));
  const { setLearnMore } = useKnowledgeBase();

  return (
    <Box>
      <Drawer
        styles={{
          drawer: {
            //portalProps: { containerRef: ref as any },
          },
          content: { px: 0, maxW: '1200px', h: 'full' },
        }}
        isOpen={isOpen}
        onClose={onClose}
        header={
          <HStack w="full" justify="space-between">
            <StackedHeader
              upper="Apply Policies To Environments"
              lower={blueprint.data?.name}
              icon={getBlueprintIcon(
                blueprint.data.created_by !== 'system',
                blueprint.data?.compliance ?? blueprint.data?.name,
              )}
              iconFilled={false}
            />
            <Box pr={4}>
              <LearnMoreButton
                onOpen={() => setLearnMore('policies')}
                label="Policies"
              />
            </Box>
          </HStack>
        }
        body={
          <Box h="full">
            <UpdateConfig onCancel={onClose} onSuccess={onSuccess} />
          </Box>
        }
      />
    </Box>
  );
};
